import React, { useEffect, useState } from 'react';
import { posFormasAdmin, posCrearForma, posEditarForma, posBorrarForma } from '../services/api';

const TIPOS = [
  { v: 'efectivo', l: 'Efectivo (teclado + arqueo)' },
  { v: 'tarjeta', l: 'Tarjeta (datáfono)' },
  { v: 'qr', l: 'QR / Bre-B (SnelPay)' },
  { v: 'otro', l: 'Otro (cobro directo)' },
];
// Códigos DIAN de medio de pago más usados (para la factura electrónica).
const CODIGOS = ['10 Efectivo', '20 Cheque', '42 Consignación/QR', '47 Transferencia', '48 Tarjeta débito', '49 Tarjeta crédito', '71 Bonos', 'ZZZ Otro'];

export default function FormasPago() {
  const [formas, setFormas] = useState([]);
  const [flash, setFlash] = useState(null);
  const aviso = (ok, t) => { setFlash({ ok, t }); setTimeout(() => setFlash(null), 3500); };
  const cargar = () => posFormasAdmin().then(r => setFormas(r.data || [])).catch(() => {});
  useEffect(() => { cargar(); }, []);

  const set = (i, patch) => setFormas(fs => fs.map((f, j) => j === i ? { ...f, ...patch } : f));
  const guardar = async (f) => {
    try { await posEditarForma(f.id, f); aviso(true, '✅ Guardado'); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo guardar')); }
  };
  const borrar = async (f) => {
    try { const { data } = await posBorrarForma(f.id); aviso(true, data.desactivada ? 'Forma desactivada (tiene ventas)' : 'Forma eliminada'); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo eliminar')); }
  };
  const agregar = async () => {
    try { await posCrearForma({ nombre: 'Nueva forma', tipo: 'otro', codigo_dian: 'ZZZ', orden: (formas.length + 1) * 10 }); cargar(); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo crear')); }
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Formas de pago</h1><p style={s.sub}>Medios de pago que aparecen en el Punto de Venta</p></div>
        <button style={s.btnPrimary} onClick={agregar}>+ Agregar forma</button>
      </div>
      {flash && <div style={{ ...s.flash, background: flash.ok ? '#064e3b' : '#3f1d1d', color: flash.ok ? '#6ee7b7' : '#fca5a5' }}>{flash.t}</div>}

      <div style={{ ...s.card, overflowX: 'auto' }}>
        <table style={s.table}>
          <thead><tr>{['Nombre', 'Tipo', 'Código DIAN', 'Orden', 'Activa', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {formas.map((f, i) => (
              <tr key={f.id}>
                <td style={s.td}><input style={{ ...s.in, width: 160 }} value={f.nombre} onChange={e => set(i, { nombre: e.target.value })} /></td>
                <td style={s.td}>
                  <select style={{ ...s.in, width: 200 }} value={f.tipo} onChange={e => set(i, { tipo: e.target.value })}>
                    {TIPOS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
                  </select>
                </td>
                <td style={s.td}>
                  <input list="codigos-dian" style={{ ...s.in, width: 110 }} value={f.codigo_dian} onChange={e => set(i, { codigo_dian: e.target.value.split(' ')[0] })} />
                </td>
                <td style={s.td}><input type="number" style={{ ...s.in, width: 64 }} value={f.orden} onChange={e => set(i, { orden: e.target.value })} /></td>
                <td style={s.td}><input type="checkbox" checked={f.activo} onChange={e => set(i, { activo: e.target.checked })} /></td>
                <td style={{ ...s.td, whiteSpace: 'nowrap' }}>
                  <button style={s.btnSm} onClick={() => guardar(f)}>Guardar</button>
                  <button style={{ ...s.btnSm, color: '#fca5a5', borderColor: '#7f1d1d' }} onClick={() => borrar(f)}>Eliminar</button>
                </td>
              </tr>
            ))}
            {formas.length === 0 && <tr><td colSpan={6} style={{ padding: 24, textAlign: 'center', color: '#64748b' }}>Sin formas de pago.</td></tr>}
          </tbody>
        </table>
        <datalist id="codigos-dian">{CODIGOS.map(c => <option key={c} value={c} />)}</datalist>
      </div>
      <p style={{ ...s.sub, marginTop: 10 }}>El <b>tipo</b> define el comportamiento en el POS: <b>Efectivo</b> abre el teclado y cuenta en el arqueo; <b>QR</b> genera el cobro SnelPay; <b>Tarjeta/Otro</b> cobran directo. El <b>código DIAN</b> es el medio de pago que va en la factura electrónica.</p>
    </div>
  );
}

const s = {
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14, gap: 12, flexWrap: 'wrap' },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 14 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px 10px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155' },
  td: { padding: '8px 10px', borderBottom: '1px solid #16202e' },
  in: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '7px 9px', color: '#f1f5f9', fontSize: 13, boxSizing: 'border-box' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 16px', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  btnSm: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 7, padding: '6px 12px', fontSize: 12, cursor: 'pointer', marginRight: 6 },
  flash: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
};
